<div class="item">
  <div class="label">整体星级：</div>
  <div class="value">
    <div class="review-container">
      <span class="overall-hint" [class.active]="start1 !== 0 && start2 !== 0">
        <ng-container *ngIf="start1 !== 0 && start2 !== 0; else noPoint">
          平均评分: {{ selected }} 星
        </ng-container>
        <ng-template #noPoint> 请完成上方评分 </ng-template>
      </span>

      <div class="stars-container">
        <span class="star" *ngFor="let star of stars; let i = index">
          <svg>
            <defs>
              <linearGradient [attr.id]="'grad-' + i">
                <stop offset="0%" stop-color="#0e7a66"></stop>
                <stop [attr.offset]="getFill(i)" stop-color="#0e7a66"></stop>
                <stop [attr.offset]="getFill(i)" stop-color="#e8e8ed"></stop>
                <stop offset="100%" stop-color="#e8e8ed"></stop>
              </linearGradient>
            </defs>
            <path
              [attr.fill]="'url(#grad-' + i + ')'"
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
            ></path>
          </svg>
        </span>
      </div>
    </div>
  </div>
</div>
